import { Module } from "wrapper6";

var $ = jQuery;

export default class Donation extends Module {

    ready(app) {

        const DONATION_AMOUNT = $('.donation-amount');
        const DONATION_RADIOS = $('.donation-radio');

        DONATION_RADIOS.on('click', function() {
            DONATION_AMOUNT.val('');
            DONATION_AMOUNT.removeClass('active');
        });
        
        DONATION_AMOUNT.on('input', function() {
            console.log('Change');
            if(DONATION_AMOUNT.val() !== ''){
                $('.donation-radio').prop('checked', false);
                DONATION_AMOUNT.addClass('active');
            }else {
                DONATION_AMOUNT.removeClass('active');
            }
		});

    }
}